<template>
	<div class="parent" style="height:calc(100vh - 50px);">
        <layout-7 
            :id=pageid 
            :term="''" 
            :title="'Employees'" 
            :binds="[]" 
            :edit_types="[null,'Value','Value','LocalOffice','EmployeeStatus','DateTime',null,null]" 
            :edit_perm="'131'" 
            style="width:100%; height:100%;"
            :isAdd="true"
            :addDefault="['N/A','','','','','','','']"
        ></layout-7>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
	data(){
		return{
			perms:[],
            pageid:PAGES.EDIT_EMPLOYEE_PAGE,
		}
	},
	async created () {
		this.perms = api.getPerms();
	},
	methods:{
		test(){
			
		},
	},
}
</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/edit/Edit_Employees.vue